import React, { useEffect, useState } from 'react';
import { api } from '../../Api';

/**
 * Recuperações em aberto do aluno (período ou final) — aviso para os pais.
 * Some sozinho quando o professor lança a nota da recuperação.
 * Em caso de erro devolve lista vazia (o aviso nunca quebra a tela).
 */
export function useRecuperacaoPendente(id_student) {
    const [pendentes, setPendentes] = useState([]);
    useEffect(() => {
        let ativo = true;
        if (!id_student) { setPendentes([]); return undefined; }
        api.post('/recovery/pending', { id_student })
            .then((r) => { if (ativo) setPendentes(r?.data?.pendentes || []); })
            .catch(() => { if (ativo) setPendentes([]); });
        return () => { ativo = false; };
    }, [id_student]);
    return pendentes;
}

const tituloCaso = (s) => String(s || '').toLowerCase().replace(/(^|\s)\S/g, (l) => l.toUpperCase());

// "Matemática (1º Bimestre), Português (recuperação final)"
export function descreverPendentes(pendentes = []) {
    return pendentes
        .map((p) => `${tituloCaso(p.materia)} (${p.tipo === 'final' ? 'recuperação final' : tituloCaso(p.periodo)})`)
        .join(', ');
}

/** Selo compacto para a lista de alunos do responsável. */
export function SeloRecuperacao({ id_student }) {
    const pendentes = useRecuperacaoPendente(id_student);
    if (!pendentes.length) return null;
    const temFinal = pendentes.some((p) => p.tipo === 'final');
    return (
        <span
            title={`Em recuperação: ${descreverPendentes(pendentes)}`}
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 4, alignSelf: 'flex-start',
                padding: '2px 9px', borderRadius: 999, fontSize: 11.5, fontWeight: 800, whiteSpace: 'nowrap',
                background: '#fde8e8', border: '1px solid #dc2626', color: '#b91c1c', margin: '4px 0',
            }}
        >
            ⚠️ {temFinal ? 'Em recuperação final' : 'Em recuperação'}
        </span>
    );
}

/** Aviso no painel do aluno (acima do gráfico de desempenho). */
export function AvisoRecuperacao({ id_student, nome }) {
    const pendentes = useRecuperacaoPendente(id_student);
    if (!pendentes.length) return null;
    const periodo = pendentes.filter((p) => p.tipo !== 'final');
    const final = pendentes.filter((p) => p.tipo === 'final');
    const primeiroNome = String(nome || 'O aluno').trim().split(/\s+/)[0];
    return (
        <div role="alert" style={{
            background: '#fde8e8', border: '1px solid #dc2626', color: '#7f1d1d',
            borderRadius: 12, padding: '12px 14px', margin: '12px 0', fontSize: 14, lineHeight: 1.45,
        }}>
            <div style={{ fontWeight: 800, marginBottom: 4 }}>⚠️ {primeiroNome} está em recuperação</div>
            {periodo.length > 0 && (
                <div><strong>Recuperação do período:</strong> {descreverPendentes(periodo)}.</div>
            )}
            {final.length > 0 && (
                <div><strong>Recuperação final:</strong> {final.map((p) => tituloCaso(p.materia)).join(', ')}.</div>
            )}
            <div style={{ fontSize: 12.5, marginTop: 4, color: '#991b1b' }}>
                Procure o professor ou a escola para saber as datas e o conteúdo. Este aviso some quando a nota da recuperação for lançada.
            </div>
        </div>
    );
}

export default AvisoRecuperacao;
